import { render, staticRenderFns } from "./OrmMessageDetail.vue?vue&type=template&id=4d005a56"
import script from "./OrmMessageDetail.vue?vue&type=script&lang=js"
export * from "./OrmMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./OrmMessageDetail.vue?vue&type=style&index=0&id=4d005a56&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d005a56')) {
      api.createRecord('4d005a56', component.options)
    } else {
      api.reload('4d005a56', component.options)
    }
    module.hot.accept("./OrmMessageDetail.vue?vue&type=template&id=4d005a56", function () {
      api.rerender('4d005a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormmessage/OrmMessageDetail.vue"
export default component.exports